<p-dialog
  [appendTo]="appendTo || 'body'"
  [baseZIndex]="20000"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px' }"
  [header]="(season?.cropName || season?.plantingDate ? 'SEASON_PLANTING_INFO' : 'FIELD_DETAILS') | translate"
  (onHide)="onHide()"
>
  <ng-template pTemplate="content">
    @if (season) {
      <div>
        <div class="field-details-content">
          <div class="detail-row">
            <span class="detail-label">{{ 'IS_MONITORING' | translate }}:</span>
            <span class="detail-value">
              @if (seasonIsMonitoring(season)) {
                {{ 'Yes' | translate }}
              } @else {
                {{ 'No' | translate }}
              }
            </span>
          </div>
          @if (season.cropName || season.plantingDate || season.harvestingDate) {
            <div>
              <div class="detail-row">
                <span class="detail-label">{{ 'CROP' | translate }}:</span>
                <span class="detail-value">{{ season.cropName || '' }}</span>
              </div>
              @if (season.plannedCropId || season.plannedCropName) {
                <div class="detail-row">
                  <span class="detail-label">{{ 'PLANNED_CROP_ID' | translate }}:</span>
                  <span class="detail-value">{{ plannedCropDisplay(season) }}</span>
                </div>
              }
              <div class="detail-row">
                <span class="detail-label">{{ 'SOWING_DATE' | translate }}:</span>
                <span
                  class="detail-value">{{ season.plantingDate ? (season.plantingDate | date:'dd.MM.yyyy') : '' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">{{ 'HARVEST_TIME' | translate }}:</span>
                <span
                  class="detail-value">{{ season.harvestingDate ? (season.harvestingDate | date:'dd.MM.yyyy') : '' }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    @if (season) {
      <button
        pButton
        type="button" [label]="'SHOW_MORE' | translate" (click)="onShowMore()"
        class="show-more-btn"
      ></button>
    }
    @if (season) {
      <button
        pButton
        type="button" [label]="'Edit' | translate"
        (click)="onEdit()"
        class="edit-btn"
      ></button>
    }
  </ng-template>
</p-dialog>
